<template>
    <v-app :class="{mobile: isMobile}">
        <v-main>
            <router-view/>
        </v-main>
    </v-app>
</template>
<script>

    export default {
        name: 'App',
        data: () => ({
            //
        }),
        beforeMount() {
            //Initially set the iframe height to 1000px.
            window.parent.postMessage(["lgtDocVerifierHeight", 1000], "*");
            //Send actual height to parent who owns the iframe.
            window.onload = () => {
                setTimeout(()=>{
                    const height = document.documentElement.scrollHeight;
                    window.parent.postMessage(["lgtDocVerifierHeight", height], "*");
                    // console.log("Sent height", height);
                }, 500); //Give some delay for scrollHeight to return proper value.
            };
        }
    };
</script>

<style scoped lang="scss">


    @import "@/styles/variables.scss";


    #app {
        font-family: Poppins, 'sans-serif';
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #000;
        @if $withMSBSDE {
            width: 1170px !important;
        }
        width: 100%;
        height: 100%;
        margin: 0 auto !important;
    }


    .mobile#app {
        @if $withMSBSDE {
            width: 93% !important;
        }
    }

    #nav {

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }


    .v-main {
        overflow-y: hidden; /*Hide scroll bar that's coming for this particular section*/
    }


</style>
